module.exports = __webpack_public_path__ + "media/images/checkout/pix-checkout-3f52d6d61aec103d32675fafbbc7e054.png";